import $ from "jquery";
import { initializeApEditor } from "./wysiwyg.js";

/******************************************************************************
 **  Enso Modal
 ******************************************************************************/
(function($) {
  $.fn.ensoModal = function(action, preRenderFunction) {
    var destroy = function() {
      $(".enso-modal").remove();
      $(".enso-modal-mask").remove();
    };

    if (typeof preRenderFunction === "undefined") {
      preRenderFunction = function() {};
    }

    if (typeof action === "undefined" || action == "open") {
      // destroy any currently open modals

      destroy();

      var $content = $(this);

      var $h1 = $content.find("h1");

      var $body = $("body");
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      var documentHeight = $(document).height();
      var documentWidth = $(document).width();
      var windowCentreX = windowWidth / 2;
      var scrollTop = $(window).scrollTop();
      var windowCentreY = scrollTop + windowHeight / 2;

      //do something with scrollTop!

      // get the width of the content we are going to insert into the modal
      // we must do this by drawing to the screen first, but we do it in a hidden div
      var $hiddenPreview = $("<div>")
        .css({
          position: "absolute",
          //'left': -10000,   //draw it off screen
          left: 0, //draw it off screen
          top: 0
        })
        .attr("id", "hidden-preview")
        .appendTo("body");
      $content.prependTo($hiddenPreview);
      preRenderFunction();
      var modalWidth = $hiddenPreview.width();
      var modalHeight = $hiddenPreview.width();

      var modalLeft = windowCentreX - modalWidth / 2;
      var modalTop = windowCentreY - modalHeight / 2;
      if (modalTop < 0) {
        modalTop = 20;
      }

      var $modalMask = $("<div></div>");
      $modalMask.addClass("enso-modal-mask").css({
        position: "fixed",
        "z-index": 100,
        width: "100%",
        height: "100%",
        left: 0,
        top: 0
      });

      var $modal = $("<div></div>");
      $modal.addClass("enso-modal").css({
        width: modalWidth,
        height: modalHeight,
        top: modalTop,
        left: modalLeft,
        position: "absolute",
        "z-index": 101
        //                     'overflow-y': 'auto'
      });

      var $closeButton = $('<a class="close-btn">×</a>');

      $closeButton.on("click", destroy);

      $content.prependTo($modal);
      $content.wrap('<div class="modal-body"></div>');
      $h1.prependTo($modal);
      $closeButton.prependTo($modal);

      $modalMask.appendTo($body);
      $modal.appendTo($body);
      return this;
    } else if (action === "destroy") {
      destroy();
    }
  };

  /* useful for when you want only the first click of a form to be sent */
  $.fn.preventDoubleClick = function() {
    $(this).on("click", function(e) {
      if ($(this).data("clicked") == true) {
        e.preventDefault();
        e.stopPropagation();
        console.log('double click prevented using data("clicked")');
      } else {
        $(this).data("clicked", true);
      }
    });
    $(this).on("dblclick", function(e) {
      console.log("double click prevented using dblclick event");
      e.preventDefault();
      e.stopPropagation();
    });
  };

  $.fn.getOuterHtml = function() {
    var $wrapper = $("<wrapper>");
    this.each(function(i, e) {
      $wrapper.append($(e).clone());
    });
    return $wrapper.html();
  };

  $.fn.isEmptyNode = function() {
    var empty;
    var $e = $(this.get(0));
    if ($e.text().trim() == "") {
      return true;
    } else {
      return false;
    }
  };

  $.fn.removeEmptyNodes = function() {
    this.children().each(function(i, e) {
      var $e = $(e);
      if ($e.text().trim() == "") {
        $e.remove();
      } else {
        $e.removeEmptyNodes();
      }
    });
  };

  $.fn.removeClassesRecursive = function() {
    this.removeAttr("class");
    this.children().each(function(i, e) {
      $(e).removeClassesRecursive();
    });
  };

  $.fn.removeAttributesRecursive = function() {
    var $e = this;

    var attributes = $e.get(0).attributes;

    for (var i = 0; i < attributes.length; i++) {
      var attribute = attributes[i];
      if (attribute.specified) {
        $e.removeAttr(attribute.name);
      }
    }
    $e.children().each(function(i, e) {
      $(e).removeAttributesRecursive();
    });
  };
})(jQuery);

export function openFormModal(
  jquery_ajax_args,
  formClosedCallback,
  formInitializedCallback
) {
  $.ajax(jquery_ajax_args).done(function(html) {
    html = $.trim(html); // trim whitespace to make it jquery1.9 compatible: http://bugs.jquery.com/ticket/13223
    var $relatedFormWrapper = $("<div>" + html + "</div>");
    $relatedFormWrapper.ensoModal();

    var $relatedForm = $relatedFormWrapper.find("form");

    if (typeof formInitializedCallback !== "undefined") {
      formInitializedCallback($relatedFormWrapper);
    }

    for (let textInput of $relatedFormWrapper.find("[js-ap-editor]")) {
      initializeApEditor(textInput);
    }

    $relatedForm.ajaxForm(function(response) {
      $relatedFormWrapper.ensoModal("destroy");
      formClosedCallback(response);
    });
  });
}

/******************************************************************************
 ** Tab Sets
 ******************************************************************************/

(function($) {
  $.fn.tabSet = function() {
    // items in tab sets must be rendered with the following structure:
    //      <div class="tab-section"><h2>***<h2><div class="tab-content">***</div><div>
    // if JS is turned off, the content is rendered as separate sections rather than as tabs
    // this plugin makes this content tabbable

    return this.each(function(i, e) {
      var $tabSet = $(e);
      var $sections = $tabSet.find(".tab-section");
      var $tabs = $tabSet.find(".sub-nav > li");
      var $activeTab = $tabs.filter(".active");
      var $activeSection = getSection($activeTab);
      $activeSection.addClass("active");
      $sections.find("h2").remove();
      $sections.not(".active").hide();

      $tabs.on("click", function(e) {
        e.preventDefault();
        var $tab = $(this);
        $tabs.removeClass("active");
        $tab.addClass("active");
        var $section = getSection($tab);
        $sections.removeClass("active").hide();
        $section.addClass("active");
        $section.show();
      });

      /**
             * @param tab  (can be the name of a section or a tab JQ object)
             */
      function getSection(tab) {
        if (typeof tab === "string") {
          var name = tab;
        } else {
          var name = getSectionName(tab);
        }
        return $tabSet.find('[name="' + name + '"]').parent();
      }

      function getSectionName($tab) {
        return $tab.find("a").attr("href").substr(1);
      }
    });
  };
})(jQuery);

/******************************************************************************
 ** Tabbed Fieldsets
 ******************************************************************************/
(function($) {
  $.fn.tabbedFieldsets = function() {
    return this.each(function(i, e) {
      var $fieldsets = $(e).find("fieldset");
      var $firstFieldset = $fieldsets[0];
      var $tabs = $('<ul class="sub-nav">');
      $tabs.addClass("fieldset-tabs");
      $tabs.insertBefore($firstFieldset);
      $fieldsets.each(function(i, e) {
        var $legend = $(this).find("legend");
        var $li = $("<li>")
          .attr("data-fieldset-index", i)
          .on("click", function(e) {
            e.preventDefault();
            var fieldsetIndex = $(this).data("fieldset-index");
            console.log(fieldsetIndex);
            $fieldsets.hide();
            $($fieldsets[fieldsetIndex]).show();
            $lis.removeClass("active");
            $(this).addClass("active");
          });
        $('<a href=""></a>').text($legend.text()).prependTo($li);
        $li.appendTo($tabs);
        $tabs.find("li:first").addClass("active");

        $(this).find("legend").hide();
      });

      var $lis = $tabs.find("li");
      for (var i = 1; i < $fieldsets.length; i++) {
        $($fieldsets[i]).hide();
        //                $fieldsets[i].remove();
      }
    });
  };
})(jQuery);

/******************************************************************************
 ** Vertical Drop Down
 ******************************************************************************/

(function($) {
  $.fn.ensoVerticalDropdown = function() {
    return this.each(function(i, e) {
      $(e)
        .on("mousemove", function() {
          $(this).find("ul").show();
        })
        .on("mouseleave", function() {
          $(this).find("ul").hide();
        })
        .on("mouseleave", "ul", function() {
          $(this).hide();
        });
    });
  };
})(jQuery);

/******************************************************************************
 **  Other
 ******************************************************************************/
export function getMimeObject(mimeTypeStr) {
  var a = mimeTypeStr.split("/");
  return {
    mediaType: a[0],
    subType: a[1]
  };
}

export function stripExtension(s) {
  return s.replace(/\.[^/.]+$/, "");
}

/******************************************************************************
 **  DOM Manipulation
 ******************************************************************************/

(function($) {
  var NODE_TYPES = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };

  $.fn.getNodeType = function() {
    return this.get(0).nodeType;
  };

  $.fn.isElementNode = function() {
    return $(this).getNodeType() == NODE_TYPES.ELEMENT_NODE;
  };

  $.fn.isTextNode = function() {
    return $(this).getNodeType() == NODE_TYPES.TEXT_NODE;
  };
})(jQuery);

export function crossDomainAjax(url, callback) {
  // from http://ajaxian.com/archives/using-yql-as-a-proxy-for-cross-domain-ajax
  var yql_url =
    "http://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20html%20where%20url%3D%22" +
    encodeURIComponent(url) +
    "%22&format=xml'&callback=?";

  console.log(yql_url);

  $.getJSON(yql_url, function(data) {
    callback(data);
  });
}

/******************************************************************************
 ** Javascript Extensions
 ******************************************************************************/

String.prototype.capitalizeFirstLetter = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/enso-plugins.js